module.exports = __webpack_public_path__ + "img/DROP-5-820x1024.cc1a8692.png";